import { Injectable } from '@angular/core';
import { Environment, ProjectConfig, SigvRetailConfig } from './common.config';
import { EnvConfig } from './env.config';

@Injectable()
export class AppContext {
  public static readonly envConfig: EnvConfig = {} as any;
  envConfig: EnvConfig = {} as EnvConfig;
  projectConfig: ProjectConfig = {} as ProjectConfig;
  environment: Environment = {} as Environment;
  sigvRetailConfig: SigvRetailConfig = {
    disableHttpInterceptor: false,
    enabledServiceWorker: false,
  } as SigvRetailConfig;
}
